import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URI,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-auth-token': window.localStorage.getItem('x-auth-token'),
    'Authorization': 'Basic ' + process.env.VUE_APP_BASIC_AUTH
  },
  timeout: 50000
})

export default {
  updateToken () {
    apiClient.defaults.headers['x-auth-token'] = `${
      window.localStorage.getItem('x-auth-token')
    }`
  },
  getPDF (hash) {
    return apiClient.get('/user-report/' + hash)
  }
}
